import { Page } from "../components/ui";
import ListUsers from "../components/sidekick/users/ListUsers";

function UserAdmin() {
  return (
    <Page>
      <ListUsers />
    </Page>
  );
}

export default UserAdmin;
